import React from "react";
import PaddedSection from "../PaddedSection";
import styled from "styled-components";
import {primaryTextColour, tableBorderColour} from "../../../../style/styleConsts";
import {CommentaryCell, CommentaryHeader} from "./HistoricalCommentary";
import {ActionCell, ActionHeader} from "./IdeaAction";
import {ActionTime, ActionTimeHeader} from "./ActionTime";

const Container = styled(PaddedSection)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-bottom: 37px;
    min-width: 700px;
`;

const Header = styled.div`
    display: flex;
    font-weight: normal;
    color: ${primaryTextColour};
    font-size: 14px;
    padding-left: 6px;
    padding-right: 6px;
    padding-bottom: 12px;
    text-align: left;
`;

const Row = styled(Header)`
    ${({newDay}) => newDay ? `
        border-top: 1px solid ${tableBorderColour};
        padding-top: 12px;
    ` : ""};
`;

function closedForAll(portfolios, index) {
    return index === 0 && portfolios.filter(p => p.open).length === 0;
}

const IdeaDetailsHistoryTab = ({idea, ideaActions, history}) => {
    function generateRows() {
        const output = [];
        let previousDay = null;
        let index = 0;
        for (const row of idea.activity) {
            output.push(
                <Row key={index} newDay={row.day !== previousDay}>
                    <ActionTime activity={row} newDay={row.day !== previousDay}/>
                    <ActionCell activity={row}
                                activityId={idea.activity.length - index}
                                closedForAll={closedForAll(idea.portfolios, index)}
                                ideaActions={ideaActions}
                                expanded={history.expanded}/>
                    <CommentaryCell activity={row} idea={idea}/>
                </Row>
            );
            previousDay = row.day;
            ++index;
        }
        return output;
    }

    return (
        <Container className="t-history-content">
            <Header>
                <ActionTimeHeader/>
                <ActionHeader/>
                <CommentaryHeader/>
            </Header>
            <div className="t-history-table">
                {generateRows()}
            </div>
        </Container>
    );
};

export default IdeaDetailsHistoryTab;
